import { AxiosRequestConfig } from 'axios';
import axiosInstance from './config';

// (GET, POST, PUT, DELETE)
const getRequest = async <T>(
  url: string,
  config: AxiosRequestConfig = {},
): Promise<T> => {
  const response = await axiosInstance.get(url, config);
  return response.data;
};

const postRequest = async <T, D>(
  url: string,
  data?: D,
  config: AxiosRequestConfig = {},
): Promise<T> => {
  const response = await axiosInstance.post(url, data, config);
  return response.data;
};

const putRequest = async <T, D>(
  url: string,
  data: D,
  config: AxiosRequestConfig = {},
): Promise<T> => {
  const response = await axiosInstance.put(url, data, config);
  return response.data;
};

const deleteRequest = async <T>(
  url: string,
  config: AxiosRequestConfig = {},
): Promise<T> => {
  const response = await axiosInstance.delete(url, config);
  return response.data;
};

/**
 * Convert axios response headers to plain Record<string, string>.
 * Keys are normalized to lowercase so callers can use headers['content-disposition'] etc
 */
const headersToRecord = (headers: unknown): Record<string, string> => {
  const out: Record<string, string> = {};
  if (!headers || typeof headers !== 'object') return out;
  Object.entries(headers as Record<string, unknown>).forEach(([key, value]) => {
    if (typeof value === 'string') out[key.toLowerCase()] = value;
  });
  return out;
};

/**
 * POST for export endpoints; returns file as Blob and response headers (e.g. Content-Disposition).
 * response.data is the Blob (body); we return { headers, data } so caller can get filename.
 */
const exportRequest = async <D>(
  url: string,
  data?: D,
  config: AxiosRequestConfig = {},
): Promise<{ headers: Record<string, string>; data: Blob }> => {
  const response = await axiosInstance.post(url, data, {
    ...config,
    responseType: 'blob',
  });
  return {
    headers: headersToRecord(response.headers),
    data: response.data as Blob,
  };
};

// Exporting
export { getRequest, postRequest, putRequest, deleteRequest, exportRequest };
